<template>
  <v-list-item-content class="pt-0 pb-0" width="400px">
    <div style="border-bottom:1px solid hsla(0,0%,100%,.12)" class="pa-2 pl-0 pr-0">
      <div class="float-left">
        <v-list-item-title class="font-weight-bold mr-4">{{ data.runnerNumber }}. {{ data.runnerName
        }}</v-list-item-title>
        <v-list-item-subtitle class="d-inline mr-5">{{ data.trackName }} R{{ data.trackNumber }} - {{ data.trackCountry
        }}</v-list-item-subtitle>
        <v-list-item-subtitle class="overline">{{ formatStartTime(moment(data.startTime)) }}</v-list-item-subtitle>
        <v-list-item-subtitle><span style="color:#00E676;margin-right:10px;">{{ betset(data.winPlc) }}</span> <span
            style="color:#DCE775;">{{ ticketStatusName('Stake') }}</span> ${{ data.stake }} <span
            style="color:#29B6F6;margin-left:10px;">Odds:</span> ${{ data.odds }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="data.status === 'unresulted'">Bet ID:{{ data.id }} Status:
          {{ data.status }}</v-list-item-subtitle>
      </div>
      <div class="float-right betPrintStatus" style="max-width:50%;" v-if="data.status === 'cancelled'">
        <h4 class="error--text text-right">CANCELLED</h4>
        <div>
          <v-btn elevation="0" color="warning" class="float-right mt-2" @click="retryBet()">Re-Try</v-btn>
        </div>
      </div>
      <div v-else-if="data.status === 'unresulted' && !data.refundOwing" class="float-right betPrintStatus">
        <h3 class="success--text text-right mb-1">SUCCESS</h3>
        <v-progress-circular v-if="sendingRefund && confirmAddTrans && !printing || (sendingRefund && !confirmAddTrans)"
          indeterminate :size="15" color="white"></v-progress-circular>
        <div v-else-if="betPrinted && reprintOn" class="reprintClear betPrintStatus">
          <v-btn elevation="0" class="float-right ml-10" color="warning" @click="onReprintClick()">Re-print</v-btn>
        </div>
      </div>
      <div class="float-right betPrintStatus" style="max-width:50%;"
        v-else-if="data.status === 'unresulted' && data.refundOwing">
        <h4 class="warning--text mr-3">PARTIAL BET!</h4>
        <div v-if="!sendingRefund && !confirmAddTrans && !tryAgain">
          <v-btn elevation="0" class=""
            @click="addTransaction(data.refundOwing, `partial bet refund - Runner name: ${data.runnerName} Race: ${data.trackName} R${data.trackNumber} ${ticketStatusName('Stake')} - ${data.stake}`, 1, data.ticketId)"
            color="warning">Refund ${{ data.refundOwing }}</v-btn>
        </div>
        <v-progress-circular v-else-if="(sendingRefund && !printing) || (sendingRefund && !confirmAddTrans)" :size="15"
          indeterminate color="white"></v-progress-circular>
        <div v-else-if="betPrinted && reprintOn" class="reprintClear betPrintStatus">
          <v-btn elevation="0" class="float-right" color="warning" @click="onReprintClick()">Re-print</v-btn>
        </div>
      </div>
      <div class="float-right betPrintStatus" style="max-width:50%;" v-else-if="data.status === 'rejected' || data.error">
        <h4 v-if="data.status === 'rejected'" class="error--text">REJECTED BET!</h4>
        <h5 v-if="data.status === 'rejected'" class="error--text">Refunded: ${{ data.stake }}</h5>
        <div v-else-if="data.error && !promptTellerPriceChange && !confirmAddTrans">
          <div v-if="isPriceChanged">
            <h4 class="error--text text-right">PRICE CHANGE!</h4>
            <div v-if="isPriceChanged" class=" text-right caption">{{ data.error }} to {{ newPrice }}</div>
          </div>
          <div v-else>
            <h4 class="error--text text-right">ERRORED BET!</h4>
            <div class="text-right caption">{{ data.error }}</div>
          </div>
          <div style="clear:both"></div>
          <div>
            <v-btn elevation="0" color="warning" class="float-right" @click="successfulTrans()">Refund
              <br>${{ data.stake }}</v-btn>
            <v-btn elevation="0" v-if="!data.error" class="float-right mr-2" @click="retryBet()">Re-Try</v-btn>
          </div>
        </div>
        <h4 v-else-if="isPriceChanged && promptTellerPriceChange" class="error--text text-right">PRICE CHANGE!</h4>
        <div v-if="isPriceChanged && promptTellerPriceChange" class=" text-right caption">{{ data.error }} to {{ newPrice }}
        </div>
        <div v-if="!sendingRefund && !confirmAddTrans">
          <div v-if="isPriceChanged && promptTellerPriceChange">
            <span v-if="!tryAgain">Retrying at higher price</span>
            <v-progress-circular v-if="!tryAgain" indeterminate :size="15" color="white"></v-progress-circular>
            <v-btn elevation="0" class="float-right" @click="successfulTrans()" color="warning">Refund
              <br>${{ data.stake }}</v-btn>
            <v-btn elevation="0" v-if="tryAgain" class="float-right mr-2" @click="acceptNewPrice()"
              color="success">Re-Send <br> @ ${{ newPrice }}?</v-btn>
          </div>
        </div>
        <v-progress-circular
          v-else-if="sendingRefund && !confirmAddTrans && !printing || (sendingRefund && !confirmAddTrans)" indeterminate
          :size="15" color="white"></v-progress-circular>
        <v-btn elevation="0" v-else-if="betPrinted && reprintOn && !promptTellerPriceChange && !data.status === 'rejected'" class="float-right"
          color="warning" @click="onReprintClick()">Re-print</v-btn>
        <v-progress-circular
          v-else-if="sendingRefund && confirmAddTrans && !printing || (sendingRefund && !confirmAddTrans)" indeterminate
          :size="15" color="white"></v-progress-circular>
      </div>
    </div>
    <UserRoleValidationModal :successCallback="reprintTicket" ref="rolevalidation" />
  </v-list-item-content>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from "vuex"
import { PRICE_DISPLAY, REPRINTAVAILABLE, USERROLE } from '../common/constants'
import UserRoleValidationModal from './UserRoleValidationModal.vue'

export default {
  data() {
    return {
      sendingRefund: false,
      confirmAddTrans: false,
      printing: false,
      promptTellerPriceChange: false,
      newPrice: null,
      tryAgain: false,
      betPrinted: false
    }
  },
  props: {
    data: Object,
    loading: Boolean,
    printProcessedBet: Function,
    clearProcessedBet: Function,
    formatStartTime: Function,
    moment: Function,
    ticketStatusName: Function,
    resendBet: Function
  },
  mounted() {
    if (this.isPriceChanged || this.data.status === 'Price has changed') {
      console.log('price changed')
      this.tryAgain = true
      this.updatePrice()
    }
    if (this.data.status === 'Bet failed' && this.data.error !== 'Betting is closed on this event') {
      this.tryAgain = true
    }
    if (this.data.status === 'unresulted' && !this.data.printed) {
      this.printSuccessBet()
      this.sendingRefund = true
    }
    if (this.data.status === 'rejected' && !this.data.printed) {
      console.log('rejected')
      this.printSuccessBet()
      this.sendingRefund = false
    }
  },
  computed: {
    ...mapGetters(['getTerminalId', 'getVenueName', 'getLastAuthUserRole', 'getTerminalLocation', 'getProcessedBets']),
    printed() {
      console.log('printed', this.data)
      return this.data.printed
    },
    betsProcessed() {
      const bets = Object.keys(this.getProcessedBets).map(
        (id) => this.getProcessedBets[id]
      );
      return bets.length > 0 ? bets : null;
    },
    reprintOn() {
      const venue = this.getVenueName
      if (REPRINTAVAILABLE[venue]) return true
      return false
    },
    isPriceChanged() {
      return this.data.error == "Price has changed"
    }
  },
  watch: {
    data: {
      handler(newData, oldData) {
        // This watcher will trigger whenever the entire data object changes
        // Check if the 'printed' property has changed
        if (newData.printed !== oldData.printed) {
          console.log('printed changed to', newData.printed);
          if (newData.printed === true || newData.printed === false) {
            this.setBetPrinted(newData.printed);
          }
        }
      },
      deep: true // Enable deep watching of the data object
    },
    betsProcessed: {
      handler() {
        const betsPrinted = this.betsProcessed.find((bet) => bet.id === this.data.id)
        if (betsPrinted) {
          this.setBetPrinted(true)
          this.sendingRefund = false
        }
      }
    }
  },
  methods: {
    ...mapActions(['deleteProcessedBet', 'setProcessingBets', 'getNewPrice', 'getTerminalToken']),
    setBetPrinted(value) {
      // Your logic to set betPrinted based on the new value
      console.log(value)
      this.betPrinted = value // You can change this condition as needed
    },
    betype(v) {
      const display = PRICE_DISPLAY
      const type = display.find(c => c.apiName === v && c.venueName === this.getVenueName)?.betType
      return type
    },

    async addTransaction(transAmt, comments, typeId, ticketId) {
      this.sendingRefund = true
      this.printing = false
      const token = await this.getTerminalToken()
      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/RedeemTicket`,
        {
          terminal_token: token,
          amount: transAmt,
          //type: 1, // REFUND
          ticket_id: ticketId,
          //reason: `${ticketId} 'Scratched / Abandoned'`,
        })
        .then(() => {
          this.successfulTrans()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    
    retryBet() {
      const updatedBet = {
        ...this.data,
        status: 'pending',
        printed: false,
        error: null,
        refundOwing: null
      }
      this.setProcessingBets(updatedBet)
      this.resendBet(updatedBet)
      this.tryAgain = false
    },
    betset(v) {
      const display = PRICE_DISPLAY
      const type = display.find(c => c.apiName === v && c.venueName === this.getVenueName)?.display
      return type
    },
    async updatePrice() {
      const display = PRICE_DISPLAY
      const type = display.find(c => c.apiName === this.data.winPlc && c.venueName === this.getVenueName)?.type
      const newPrice = await this.getNewPrice({ id: this.data.raceId, type: type, tabNo: this.data.runnerNumber })

      // console.log(newPrice, this.data.odds, this.data)
      console.log(newPrice, this.data.odds)
      if (newPrice > this.data.odds) {
        this.printing = false
        this.tryAgain = true
        const updatedBet = {
          ...this.data,
          odds: newPrice,
          status: 'pending',
          error: null,
          refundOwing: null
        }
        this.setProcessingBets(updatedBet)
        this.resendBet(updatedBet)
      } else if (newPrice < this.data.odds) {
        this.newPrice = newPrice
        this.promptTellerPriceChange = true
        this.tryAgain = true
      }
    },
    async acceptNewPrice() {
      this.tryAgain = true
      const updatedBet = {
        ...this.data,
        odds: this.newPrice,
        status: 'pending',
        error: null,
        refundOwing: null
      }
      this.setProcessingBets(updatedBet)
      this.resendBet(updatedBet)

      const display = PRICE_DISPLAY
      const type = display.find(c => c.apiName === this.data.winPlc && c.venueName === this.getVenueName)?.type
      const newPrice = await this.getNewPrice({ id: this.data.raceId, type: type, tabNo: this.data.runnerNumber })
      this.newPrice = newPrice
    },
    successfulTrans() {
      this.sendingRefund = false
      this.confirmAddTrans = true
      this.printing = false
      this.printProcessedBet({ ...this.data, refundOwing: this.data.refundOwing || this.data.stake })
    },
    setStake(v) {
      const bet = Number(v)
      const convBet = bet.toFixed(2)
      return convBet
    },
    clearThisBet() {
      this.sendingRefund = true
      setTimeout(() => {
        this.confirmAddTrans = true
        this.sendingRefund = false
        this.clearProcessedBet(this.data)
      }, 2000);
      this.confirmAddTrans = false
      // Remove bet from array of bets in store to clear it
    },
    async onReprintClick() {
      if (this.getLastAuthUserRole == USERROLE.ENDUSER) {
        this.$refs.rolevalidation.open('', "Please enter admin's credential to authorise for re-print the ticket", { zIndex: 9999 })
      } else {

        this.reprintTicket()
      }
    },
    async reprintTicket(ticketVersion = 0) {
      const token = await this.getTerminalToken();
      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/ReissueTicket`, {
        terminal_id: token,
        ticket_id: this.data.ticketId,
        version: ticketVersion
      })
        .then((result) => {
          this.printSuccessBet(result.data)
        })
        .catch((error) => {
          console.log(error)
          this.$refs.rolevalidation.close()
        })
    },
    printSuccessBet(reprintData) {
      console.log('printSuccessBet')
      this.confirmAddTrans = true
      this.printing = false
      const updatedBet = {
        ...this.data,
        refundOwing: this.data.status === 'unresulted' ? 0 : Number(this.data.stake),
        reprint: reprintData
      }
      this.printProcessedBet(updatedBet)

    }
  },
  components: {
    UserRoleValidationModal
  }
}
</script>

<style>
.reprintClear {
  display: flex;
  justify-content: space-between;
}

.reprintClear button {
  margin-left: 5px;
}

.betPrintStatus {
  min-width: 140px;
}
</style>
